import axios from 'axios'
import convertKeys from 'utils/convert-keys'

export const sendAuthenticationCode = async (username, nextUrl) => {
  const response = await axios.post(
    process.env.REACT_APP_COGNITO_AUTH_VERIFICATION_ENDPOINT_URL,
    { username, isWeb: true, nextUrl },
    {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_COGNITO_AUTH_VERIFICATION_API_KEY,
      },
    },
  )

  return {
    data: convertKeys.toCamel(response.data),
    status: response.status,
    headers: response.headers,
    ok: response.status >= 200 && response.status < 300,
  }
}
